import { normalize_text, to_array, to_number } from './view_case_details_core_helpers';
import {
  field_value,
  first_present,
  normalize_label,
  risk_choice_label,
  risk_choice_weight,
} from './view_case_details_risk_choice_helpers';

const QUESTION_ID_FIELDS = ['question_id', 'id'];
const QUESTION_TEXT_FIELDS = ['question_text', 'text', 'label'];

function payload_rows(payload) {
  return Array.isArray(payload?.data) ? payload.data : to_array(payload);
}

function row_question(row = {}) {
  return row?.question && typeof row.question === 'object' ? row.question : row;
}

function row_question_id(row = {}, question = {}) {
  return to_number(first_present([
    row?.question_id,
    row?.question,
    ...QUESTION_ID_FIELDS.map((field) => field_value(question, field)),
  ]));
}

function risk_question_text(question = {}, row = {}) {
  return normalize_text(first_present([...QUESTION_TEXT_FIELDS.map((field) => field_value(question, field)), row?.question_text]));
}

function risk_weight_options(row = {}, row_choices = []) {
  const choices = row_choices.length ? row_choices : [row];
  return choices.map((choice) => ({
    option: risk_choice_label(choice),
    weight: risk_choice_weight(choice),
  }));
}

function add_weight_row(result, row = {}) {
  const question_id = to_number(first_present([row?.question_id, row?.question]));
  const options = result.get(Number(question_id)) || [];

  if (question_id) {
    options.push(...risk_weight_options(row, to_array(row?.choices)));
    result.set(Number(question_id), options);
  }

  return result;
}

function risk_weights_by_question(payload = {}) {
  return payload_rows(payload).reduce(add_weight_row, new Map());
}

function matched_weight_for(choice, weight_lookup) {
  return weight_lookup.get(normalize_label(risk_choice_label(choice)));
}

function weighted_choice(choice, weight_lookup) {
  const matched_weight = matched_weight_for(choice, weight_lookup);
  const weight = first_present([field_value(choice, 'weight'), matched_weight?.weight, field_value(choice, 'score'), 0]);
  return typeof choice === 'object' && choice !== null
    ? { ...choice, weight }
    : { option: risk_choice_label(choice), weight };
}

function weighted_choices(choices = [], weights = []) {
  const weight_lookup = new Map(weights.map((item) => [normalize_label(risk_choice_label(item)), item]));
  return to_array(choices).map((choice) => weighted_choice(choice, weight_lookup));
}

function normalize_assigned_risk_question(row, weights_by_question) {
  const question = row_question(row);
  const question_id = row_question_id(row, question);

  return {
    id: question_id,
    text: risk_question_text(question, row),
    question_text: risk_question_text(question, row),
    choices: weighted_choices(
      first_present([question?.choices, question?.multi_select_choices, row?.choices, []]),
      weights_by_question.get(Number(question_id)) || []
    ),
  };
}

export function assigned_risk_questions(payload = {}, weights_payload = {}) {
  const weights_by_question = risk_weights_by_question(weights_payload);
  return payload_rows(payload)
    .map((row) => normalize_assigned_risk_question(row, weights_by_question))
    .filter((question) => question.id);
}
